import $ from 'jquery';

const progressRing = (root = document.documentElement) => {
  const circle = $(root).find('.c-progress__ring-circle');
  if (circle.length) {
    circle.each((i, item) => {
      /* eslint-disable */
      item.style.strokeDashoffset = item.getAttribute('data-dashoffset');
      /* eslint-enable */
    });
  }
};
export default progressRing;



// WEBPACK FOOTER //
// ./src/scripts/modules/progress-ring.js